import * as React from 'react'

import { Location } from '@thg-commerce/enterprise-network/src/generated/graphql'

import { DropdownContainer, DropdownItem } from './styles'

export interface SearchSuggestionsProps {
  searchLocations: Location[]
  handleFindStores: (Location) => void
}

export const SearchSuggestions = ({
  searchLocations,
  handleFindStores,
}: SearchSuggestionsProps) => {
  return (
    <DropdownContainer data-testid="search-suggestions">
      {searchLocations.map((location) => {
        return (
          <DropdownItem
            onClick={(event: React.MouseEvent<Element, MouseEvent>) => {
              event.stopPropagation()
              handleFindStores(location)
            }}
          >
            {`${location.displayName}`}
          </DropdownItem>
        )
      })}
    </DropdownContainer>
  )
}
